<template>
  <div class="content">
    <div class="Index">
      <div class="bg">
        <img class="bgImg" src="../assets/bg.jpg" alt />

        <div class="turntable_a">
          <div class="turntable">
            <LuckyWheel
              v-if="status"
              class="turntable_c"
              ref="myLucky"
              id="myCanvas"
              :prizes="prizes"
              :blocks="blocks"
              :buttons="buttons"
              :defaultConfig="defaultConfig"
              @start="startCallback"
              @end="endCallback"
            />
          </div>
        </div>

        <p class="playGameNum" v-if="playGameStatus">
          <span>{{ prizeNum || 0 }}</span>
          <br />剩余抽奖次数
        </p>

        <img class="turntableMoney" src="../assets/turntableMoney.png" alt />

        <img
          class="detailIcon"
          @click="openDetailAlert"
          src="../assets/detailIcon.png"
          alt
        />

        <img
          class="winIcon"
          @click="toRecord"
          src="../assets/winIcon.png"
          alt
        />

        <div class="login_btn" v-if="!playGameStatus" @click="login">
          <img src="../assets/login_btn.png" alt />
        </div>

        <div class="play_btn" v-if="playGameStatus" @click="playGame">
          <img src="../assets/play_btn.png" alt />
        </div>

        <div class="tickArea" @click="tickFunc" v-if="playGameStatus">
          <img class="tick" v-show="tickStatus" src="../assets/tick.png" alt />
        </div>

        <div class="tipsArea">
          <img class="bg1" src="../assets/bg1.png" />

          <div class="tips">
            为了感恩回馈各位新老会员
            <br />特别推出存波币摇彩金活动
            <br />凡在活动期间内使用波币累计充值1000元以上
            <br />并完成相应打码额度次日即可参与摇奖
          </div>
        </div>
      </div>

      <img
        v-if="playGameStatus"
        @click="logoutFunc"
        class="logout"
        src="../assets/logout.png"
        alt=""
      />

      <!-- 登录弹窗 -->
      <div class="login" v-if="!loginStatus">
        <div class="loginTips">
          <img src="../assets/login.png" alt />

          <div class="loginYes" @click="loginFunc"></div>
          <div class="loginClose" @click="closelogin"></div>
          <div class="tutorial" @click="toTutorial"></div>

          <div class="themeInput">
            <input
              type="text"
              v-model="vipAccount"
              placeholder="请输入您的ID"
            />
          </div>
        </div>
      </div>

      <!-- 活动详情弹窗 -->
      <div class="detailAlert" v-if="detailStatus">
        <div class="detailAlertTips">
          <img src="../assets/ruleDetail.png" alt />
          <el-table
            :data="ruleList"
            border
            class="detailTable"
            :span-method="objectSpanMethod"
            :header-cell-style="{
              background: '#fed99d',
              color: '#93231e',
              height: '55px',
              borderColor: '#ffffff',
            }"
            :row-style="{ color: '#b45252', height: '55px' }"
            :cell-style="{ borderColor: '#e7c365' }"
          >
            <el-table-column label="存款金额" align="center" min-width="25">
              <template slot-scope="{ row }">
                <span>{{ row.moneyCtl }}+</span>
              </template>
            </el-table-column>
            <el-table-column label="打码量" align="center" min-width="25">
              <template slot-scope="{ row }">
                <span>{{ row.countCtl }}+</span>
              </template>
            </el-table-column>
            <el-table-column label="摇奖次数" align="center" min-width="25">
              <template slot-scope="{ row }">
                <span>{{ row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="提款要求" align="center" min-width="25">
              <span>1倍打码</span>
            </el-table-column>
          </el-table>
          <div class="detailAlertClose" @click="closeDetailAlert"></div>

          <div class="noticeM">
            <p><span>1</span>所得优惠活动彩金需要满足1倍打码后即可提款</p>
            <p>
              <span>2</span
              >王妃直播的所有优惠为玩家而设，若发现任何团体或个人，以不诚
              实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、
              取消该团体或个人账户结余的权利
            </p>
            <p>
              <span>3</span
              >王妃直播保留对活动的最终解释权，以及在无通知的情况下修改终
              止活动的权利，适用于所有优惠
            </p>
          </div>
        </div>
      </div>

      <!-- 提示注册弹窗 -->
      <div class="register" v-if="registerStauts">
        <div class="registerTips">
          <img src="../assets/register.png" alt />

          <div class="registerYes" @click="registerFunc"></div>
          <div class="registerClose" @click="closeRegister"></div>
        </div>
      </div>

      <!-- 获奖弹窗 -->
      <div class="getred" v-show="getredStatus">
        <div class="getredTips">
          <img src="../assets/getred.png" alt />

          <div class="getredMoney">
            <i>￥</i>
            <p>{{ winMoney }}</p>
          </div>

          <div class="getredArea" @click="closeGetredFunc"></div>
          <div class="closeGetRedArea" @click="closeGetredFunc"></div>
        </div>
      </div>

      <!-- appid获取教程 -->
      <div class="tutorialAlert" v-if="tutorialStatus">
        <div class="tutorialAlertTips">
          <img src="../assets/tutorial.png" alt />

          <div class="closeTutorialIcon" @click="closeTutorial"></div>
        </div>
      </div>

      <!-- 裸聊奖品 -->
      <div class="award" v-if="awardStatus">
        <div class="awardAlert">
          <img
            v-show="awardType == 'GIFT1'"
            src="../assets/GIFT1.png"
            @click="openliao"
            alt
          />
          <img
            v-show="awardType == 'GIFT2'"
            src="../assets/GIFT2.png"
            @click="openliao"
            alt
          />
          <img
            v-show="awardType == 'GIFT3'"
            src="../assets/GIFT3.png"
            @click="openliao"
            alt
          />
          <img
            v-show="awardType == 'GIFT4'"
            src="../assets/GIFT4.png"
            @click="openliao"
            alt
          />
          <img
            v-show="awardType == 'GIFT5'"
            src="../assets/GIFT5.png"
            @click="openliao"
            alt
          />

          <div class="closeawardArea" @click="closeliao"></div>
        </div>
      </div>

      <!-- 遮罩层 -->
      <div class="mask" v-if="maskStatus"></div>
    </div>

    <Record v-if="recordStatus" :activityId="activityId" @back="back" />
  </div>
</template>

<script>
import Record from "../components/record.vue";
import {
  getzp,
  getRule,
  getRemainCount,
  getllAward,
  authLogin,
  getConfig,
  getLogout,
} from "@/api/index";
import { getToken, setToken, removeToken } from "@/utils/request";
import { Message } from "element-ui";
import pointerImg from "../assets/pointer.png";
import redImg from "../assets/red.png";
import shaonvImg from "../assets/shaonv.png";

const ACCOUNT_KEY = "z12_turntable_account";

export default {
  name: "turn-table",
  components: {
    Record,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      blocks: [{ padding: "0" }],
      prizes: [
        {
          fonts: [
            {
              text: "神秘大奖",
              top: "20%",
              fontSize: "18px",
              fontColor: "#ffffff",
            },
          ],
          imgs: [
            {
              src: shaonvImg,
              top: "40%",
              width: "36px",
            },
          ],
          background: "#f22718",
        },
        {
          fonts: [
            {
              text: "38",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffcf7a",
        },

        {
          fonts: [
            {
              text: "688",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffb7b8",
        },
        {
          fonts: [
            {
              text: "8",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffb665",
        },
        {
          fonts: [
            {
              text: "888",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffb7b8",
        },
        {
          fonts: [
            {
              text: "88",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ff6a6b",
        },
        {
          fonts: [
            {
              text: "1888",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffaa6a",
        },
        {
          fonts: [
            {
              text: "18",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffb7b8",
        },
        {
          fonts: [
            {
              text: "18888",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#fee3ae",
        },

        {
          fonts: [
            {
              text: "188",
              top: "20%",
              fontSize: "18px",
              fontColor: "#6e301f",
            },
          ],
          imgs: [
            {
              src: redImg,
              top: "40%",
              width: "35px",
            },
          ],
          background: "#ffcf7a",
        },
      ],
      buttons: [
        {
          radius: "37%",
          imgs: [
            {
              src: pointerImg,
              width: "80%",
              top: "-115%",
              left: "0%",
            },
          ],
        },
      ],
      defaultConfig: {
        gutter: "1px",
        offsetDegree: -17,
      },
      playStatus: true,
      debounce: true,
      loginStatus: true,
      playGameStatus: false,
      detailStatus: false,
      registerStauts: false,
      tutorialStatus: false,
      registerUrl: "",
      vipAccount: "",
      ruleList: [],
      getredStatus: false,
      winMoney: 0,
      prizeNum: 0,
      maskStatus: false,
      tickStatus: false,
      recordStatus: false,
      status: true,
      awardStatus: false,
      huiyinniaoUrl: "",
      luoliaoStatus: false,
      awardType: "",
      activityId: "",
    };
  },
  methods: {
    // 获取url参数的值
    getUrlUserAccount(name) {
      const queryString =
        window.location.search ||
        (window.location.hash.includes("?")
          ? window.location.hash.slice(window.location.hash.indexOf("?"))
          : "");

      return new URLSearchParams(queryString).get(name)?.trim() || "";
    },
    // 检测是否有登录状态
    restoreLogin() {
      const token = getToken();
      const account = localStorage.getItem(ACCOUNT_KEY);
      if (!token || !account) return;
      this.vipAccount = account;

      getRemainCount()
        .then((res) => {
          if (res.code !== 200) {
            removeToken();
            localStorage.removeItem(ACCOUNT_KEY);
            this.vipAccount = "";
            return;
          }

          // 先查是否有次数 没有再查聊接口
          if (res.data.count === 0) {
            // llRemainCount({
            //   appid: process.env.VUE_APP_APPID,
            //   username: this.vipAccount,
            // }).then((res) => {
            //   this.luoliaoStatus = true;
            //   this.prizeNum = res.data.count;
            //   this.loginStatus = true;
            //   this.playGameStatus = true;
            //   this.maskStatus = false;
            // });

            // 临时
            this.prizeNum = 0;
            this.loginStatus = true;
            this.playGameStatus = true;
            this.maskStatus = false;
          } else {
            this.prizeNum = res.data.count;
            this.loginStatus = true;
            this.playGameStatus = true;
            this.maskStatus = false;
          }

          this.activityId = res.data.activityId;
        })
        .catch(() => {
          removeToken();
          localStorage.removeItem(ACCOUNT_KEY);
          this.vipAccount = "";
        });
    },
    // 配置
    configFunc() {
      // 配置地址
      getConfig().then((res) => {
        res.data.forEach((v) => {
          if (v.key == "hyn_url") {
            this.huiyinniaoUrl = v.value;
          }
          if (v.key == "registration_link") {
            this.registerUrl = v.value;
          }
        });
      });
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {},
    // 抽奖结束会触发end回调
    endCallback() {
      this.debounce = true;

      // 先判断是不是裸聊
      if (this.luoliaoStatus) {
        this.awardStatus = true;
      } else {
        this.getredStatus = true;
        this.maskStatus = true;
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        if (rowIndex % this.ruleList.length === 0) {
          return {
            rowspan: this.ruleList.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 开始摇奖
    playGame() {
      if (this.debounce) {
        if (this.prizeNum === 0) {
          Message({
            message: "已经没有抽奖次数了！",
            type: "warning",
            duration: 5 * 1000,
          });
          return false;
        }

        this.debounce = false;

        // 判断是否跳过旋转
        if (this.tickStatus) {
          // 先判断是不是裸聊
          if (this.luoliaoStatus) {
            getllAward({
              appid: process.env.VUE_APP_APPID,
              username: this.vipAccount,
            }).then((res) => {
              this.winMoney = 0;
              this.prizeNum = 0;
              this.awardType = res.data.money;

              this.awardStatus = true;
              this.debounce = true;
            });
          } else {
            getzp(this.activityId).then((res) => {
              this.winMoney = res.data.money;
              this.prizeNum = res.data.count;
              // 直接弹出获奖界面
              this.getredStatus = true;
              this.maskStatus = true;
              this.debounce = true;
            });
          }
        } else {
          // 调用抽奖组件的play方法开始游戏
          this.$refs.myLucky.play();

          // 先判断是不是裸聊
          if (this.luoliaoStatus) {
            getllAward({
              appid: process.env.VUE_APP_APPID,
              username: this.vipAccount,
            }).then((res) => {
              this.winMoney = 0;
              this.prizeNum = 0;
              this.awardType = res.data.money;

              this.$refs.myLucky.stop(0);
            });
          } else {
            getzp(this.activityId).then((res) => {
              this.winMoney = String(res.data.money);
              this.prizeNum = res.data.count;
              this.prizes.forEach((v, i) => {
                if (v.fonts[0].text == this.winMoney) {
                  // 调用stop停止旋转并传递中奖索引
                  this.$refs.myLucky.stop(i);
                }
              });
            });
          }
        }
      }
    },
    // 登录
    login() {
      this.loginStatus = false;
      this.maskStatus = true;
    },
    // 跳转登录
    loginFunc() {
      if (!this.vipAccount) {
        Message({
          message: "请输入会员账号！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      authLogin({ accountName: this.vipAccount }).then((res) => {
        if (res.code !== 200) {
          this.registerStauts = true;
          this.loginStatus = true;
        } else {
          // 保存 token 到全局
          if (res.data && res.data.token) {
            setToken(res.data.token);
            console.log("Token 已保存:", res.data.token);
          }

          localStorage.setItem(ACCOUNT_KEY, this.vipAccount);

          // 获取转盘次数
          getRemainCount().then((res) => {
            // 先查是否有次数 没有再查聊接口
            if (res.data.count === 0) {
              // llRemainCount({
              //   appid: process.env.VUE_APP_APPID,
              //   username: this.vipAccount,
              // }).then((res) => {
              //   this.luoliaoStatus = true;
              //   this.prizeNum = res.data.count;
              //   this.loginStatus = true;
              //   this.playGameStatus = true;
              //   this.maskStatus = false;
              // });

              // 临时
              this.prizeNum = 0;
              this.loginStatus = true;
              this.playGameStatus = true;
              this.maskStatus = false;
            } else {
              this.prizeNum = res.data.count;
              this.loginStatus = true;
              this.playGameStatus = true;
              this.maskStatus = false;
            }

            this.activityId = res.data.activityId;
          });
        }
      });
    },
    // 退出登录
    logoutFunc() {
      getLogout().then((res) => {
        Message({
          message: res.msg,
          type: "warning",
          duration: 5 * 1000,
        });
        removeToken();
      });

      localStorage.removeItem(ACCOUNT_KEY);
      this.vipAccount = "";
      this.playGameStatus = false;
    },
    // 打开活动详情
    openDetailAlert() {
      this.detailStatus = true;
    },
    // 关闭活动详情
    closeDetailAlert() {
      this.detailStatus = false;
    },
    // 关闭登录
    closelogin() {
      this.loginStatus = true;
      this.maskStatus = false;
    },
    // 跳转注册
    registerFunc() {
      window.open(this.registerUrl);
    },
    // 关闭注册
    closeRegister() {
      this.registerStauts = false;
      this.maskStatus = false;
    },
    // 关闭中奖界面
    closeGetredFunc() {
      this.getredStatus = false;
      this.maskStatus = false;
    },
    // 勾选
    tickFunc() {
      this.tickStatus = !this.tickStatus;
    },
    // 抽奖记录
    toRecord() {
      // 判断有没有登录 没有就显示注册弹窗
      if (this.playGameStatus) {
        this.recordStatus = true;
      } else {
        this.loginStatus = false;
      }
    },
    // 打开教程
    toTutorial() {
      this.tutorialStatus = true;
      this.loginStatus = true;
    },
    // 关闭获取教程弹窗
    closeTutorial() {
      this.tutorialStatus = false;
      this.maskStatus = false;
    },
    openliao() {
      window.location.href = this.huiyinniaoUrl;
    },
    closeliao() {
      this.awardStatus = false;
    },
    back() {
      this.recordStatus = false;
    },
  },
  created() {},
  mounted() {
    this.configFunc();

    // 判断url是否有值，有的话直接登录
    const userAccount = this.getUrlUserAccount("userAccount");
    if (userAccount) {
      this.vipAccount = userAccount;
      this.loginFunc();
    } else {
      this.restoreLogin();
    }

    // 规则
    getRule().then((res) => {
      this.ruleList = res.data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.content {
  background: #ea2723;
  width: 100%;
  height: 100%;
}

.bg {
  width: 540px;
  position: relative;
  height: 1266px;
  display: flex;
  flex-direction: column;
  flex: 1;

  .bgImg {
    width: 100%;
  }
}

.container {
  width: 300px;
  height: 300px;
  background-color: red;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.turntable {
  width: 400px;
  height: 400px;
  background-size: 100%;
  position: relative;
  z-index: 1;
}

.turntable_c {
  position: absolute;
  top: -99px;
  left: -23px;
  z-index: 2;
  height: 405px !important;
  width: 405px !important;
}

.turntable_c canvas {
  height: 405px !important;
  width: 405px !important;
}

.turntable .light {
  width: 360px;
  height: 360px;
  position: absolute;
  top: 6px;
  left: 8px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  from {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.title {
  width: 516px;
  margin: 37px 0 29px 0;
  z-index: 2;
  position: relative;
}

.turntable_a {
  display: inline-block;
  top: 315px;
  position: absolute;
  left: 91px;
}

.process {
  width: 375px;
  height: 38px;
  position: absolute;
  bottom: 38px;
  left: 81px;
  z-index: 2;
}

.turntableMoney {
  width: 540px;
  height: 225px;
  position: absolute;
  top: 559px;
  left: 0;
  z-index: 2;
}

.detailIcon {
  width: 91px;
  height: 94px;
  position: absolute;
  top: 822px;
  left: 0;
  z-index: 2;
}

.winIcon {
  width: 91px;
  height: 94px;
  position: absolute;
  top: 822px;
  right: 0;
  z-index: 2;
}

.play_btn,
.login_btn {
  img {
    width: 316px;
  }
  width: 316px;
  height: 105px;
  position: absolute;
  top: 822px;
  right: 0;
  z-index: 1;
  left: 0;
  margin: 0 auto;
  cursor: pointer;
}

.getAPPID {
  margin-top: 13px;
  font-size: 18px;
  position: absolute;
  top: 85px;
  left: 20px;
  color: #fff;
  width: 251px;

  span {
    color: #f0fc52;
  }
}

.tipsArea {
  width: 509px;
  position: absolute;
  top: 968px;
  left: 50%;
  transform: translate(-50%, 0);

  .bg1 {
    width: 500px;
  }

  .tips {
    height: 100px;
    font-size: 20px;
    color: #823330;
    display: flex;
    justify-content: center;
    padding: 35px 20px;
    line-height: 44px;
    margin-top: -250px;
  }
}

.playGameNum {
  height: 55px;
  width: 246px;
  line-height: 14px;
  color: #860b0a;
  font-size: 12px;
  position: absolute;
  top: 413px;
  left: 149px;
  z-index: 2;
  margin: 0 auto;

  span {
    font-size: 63px;
    font-weight: bold;
    color: #840606;
  }
}

.tickArea {
  background: url("../assets/tickArea.png") no-repeat;
  background-size: 100%;
  position: absolute;
  left: 214px;
  top: 920px;
  z-index: 3;
  width: 107px;
  height: 20px;

  .tick {
    width: 22px;
    position: absolute;
    right: -1px;
    bottom: -1px;
  }
}

.titleImg {
  width: 100%;
  margin-top: 35px;
}

.noticeM {
  position: absolute;
  margin: 0 auto;
  box-sizing: border-box;
  width: calc(100% - 70px);
  left: 50%;
  top: 538px;
  transform: translate(-50%, 0);

  p {
    font-size: 15px;
    color: #b45252;
    line-height: 25px;
    text-align: justify;
    margin-bottom: 10px;

    span {
      background: #b45252;
      color: #fff;
      padding: 1px 5px;
      border-radius: 6px;
      margin-right: 5px;
    }
  }
}

.register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .registerTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 540px;
    }

    .registerYes {
      position: absolute;
      left: 78px;
      bottom: 132px;
      width: 384px;
      height: 81px;
      cursor: pointer;
      border-radius: 12px;
    }

    .registerNo {
      position: absolute;
      left: 207px;
      bottom: 27px;
      width: 148px;
      height: 44px;
      cursor: pointer;
      border-radius: 12px;
    }

    .registerClose {
      position: absolute;
      right: 236px;
      bottom: 21px;
      width: 70px;
      height: 70px;
      cursor: pointer;
      border-radius: 12px;
    }
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .loginTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 540px;
    }

    .loginYes {
      position: absolute;
      left: 75px;
      bottom: 189px;
      width: 385px;
      height: 82px;
      cursor: pointer;
      border-radius: 12px;
    }

    .loginClose {
      position: absolute;
      left: 235px;
      bottom: 19px;
      width: 70px;
      height: 70px;
      cursor: pointer;
      border-radius: 12px;
    }

    .tutorial {
      position: absolute;
      left: 286px;
      bottom: 143px;
      width: 102px;
      height: 34px;
    }

    .themeInput {
      position: absolute;
      top: 312px;
      left: 50%;
      width: 300px;
      transform: translate(-50%, 0);

      input {
        background: none;
        border: 0;
        color: #646463;
        font-size: 25px;
        width: 300px;
        text-align: center;

        &::placeholder {
          color: #646463;
          font-size: 25px;
        }
      }

      input[type="text"]:focus {
        outline: none;
      }
    }
  }
}

.detailAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .detailAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 526px;
    }

    .detailAlertClose {
      position: absolute;
      left: 231px;
      bottom: 7px;
      width: 65px;
      height: 66px;
      cursor: pointer;
      border-radius: 12px;
    }
  }
}

.getred {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .getredTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 540px;
    }

    .getredArea {
      position: absolute;
      left: 141px;
      bottom: 154px;
      width: 257px;
      height: 76px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetRedArea {
      position: absolute;
      left: 236px;
      bottom: 14px;
      width: 68px;
      height: 68px;
      cursor: pointer;
      border-radius: 25px;
    }

    .getredMoney {
      position: absolute;
      left: 50%;
      bottom: 247px;
      transform: translate(-50%, 0);
      height: 116px;
      line-height: 116px;
      display: flex;

      p {
        font-size: 78px;
        font-weight: bold;
        color: #fff;
      }

      i {
        color: #fff;
        font-size: 36px;
        display: block;
        font-weight: bold;
        transform: translate(-7px, 15px);
        font-style: normal;
      }
    }
  }
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.playGameRecord {
  position: fixed;
  right: 0;
  top: 35%;
  cursor: pointer;
  color: #fff;
  height: 35px;
  line-height: 35px;
  width: 110px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
}

.detailTable {
  width: calc(100% - 70px);
  border: 1px solid #e7c365;
  position: absolute;
  left: 50%;
  top: 85px;
  transform: translate(-50%, 0);
  border-radius: 15px;
  background: none;
}

.el-table /deep/ tr {
  background: none;
}

.el-table /deep/ .cell {
  font-size: 18px !important;
  /* 单元格内文字的字体大小 */
  line-height: normal !important;
  padding: 0 !important;
  background: none;
}

.el-table /deep/ .el-table__header .cell {
  padding: 0 !important;
}

.tutorialAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .tutorialAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 500px;
    }

    .tutorialAlertYes {
      position: absolute;
      left: 76px;
      bottom: 144px;
      width: 248px;
      height: 62px;
      cursor: pointer;
      border-radius: 12px;
    }

    .closeTutorialIcon {
      position: absolute;
      right: 14px;
      top: 12px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.award {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .awardAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 450px;
    }

    .awardLiao {
      position: absolute;
      left: 16px;
      bottom: 22px;
      width: 419px;
      height: 55px;
      cursor: pointer;
      border-radius: 25px;
    }

    .awardArea {
      position: absolute;
      left: 53px;
      bottom: 29px;
      width: 342px;
      height: 50px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeawardArea {
      position: absolute;
      right: 6px;
      top: 43px;
      width: 61px;
      height: 56px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.logout {
  position: absolute;
  right: 10px;
  top: 20px;
  width: 139px;
  height: 31px;
}
</style>
